/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export const enum Routes {
  BASE = '/',
  LOGIN = '/login',
  LOGIN_MANAGER = '/login/manager',
  PACKING_LIST = '/product/packing-list',
  PACKING_LIST_DETAILS = '/product/packing-list/details',
  SELECTION = '/_/selection',
}

export const AttachmentUploadFilePath = 'uploadFiles/documentosBoston';
